<template>
  <div>
    <filter-label
        v-for="item in items"
        :key="item.key"
        :item="item"
        @clear="onClear"
    ></filter-label>
  </div>
</template>

<script>
import FilterLabel from './label';

export default {
  components: {
    FilterLabel,
  },

  props: {
    namespace: {
      type:String,
      default: 'filter1'
    },
  },

  computed: {
    /**
     * @return {Array}
     */
    items() {
      return this.$store.state[this.namespace].labels;
    },
  },

  methods: {
    /**
     * @param {string} name
     * @param {Object} values
     */
    onClear({name, values}) {
      this.$store.commit(`${this.namespace}/updateFilters`, {name, values});
    },
  },
}
</script>
